import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube",
  "use": "youtube-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"youtube\"><path fill=\"currentColor\" d=\"M15.55 3.28H4.45C2.27 3.28.5 5.05.5 7.23v5.55c0 2.18 1.77 3.95 3.95 3.95h11.11c2.18 0 3.95-1.77 3.95-3.95V7.22a3.958 3.958 0 0 0-3.96-3.94zm-2.66 6.99-5.2 2.48c-.14.07-.3-.03-.3-.19V7.45c0-.16.16-.26.3-.19l5.2 2.63c.15.08.15.31 0 .38z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol